export const VITE_APP_ATMO_SERVICE_ID = import.meta.env
  .VITE_APP_ATMO_SERVICE_ID;
